export default {
  name: "BolideAssistantComposer",

  props: {
    model_value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Ask me anything...",
    },
    scope: {
      type: Object,
      default: null,
    },
    compare_property_options: {
      type: Array,
      default: () => [],
    },
    compare_property_ids: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["update:model_value", "send", "update:compare_property_ids"],

  data() {
    return ({
      is_compare_drawer_open: false,
    });
  },

  computed: {
    show_compare_selector() {
      return this.scope?.level === "portfolio" && this.compare_property_options.length > 1;
    },

    selected_compare_property_count_label() {
      const count = this.normalized_compare_property_ids().length;
      return count ? `${count} selected` : "None selected";
    },

    selected_compare_property_summary() {
      const selected_labels = this.compare_property_options
        .filter((property) => this.is_compare_property_selected(property.id))
        .map((property) => property.label);

      if (!selected_labels.length) {
        return "No properties selected";
      }

      if (selected_labels.length <= 2) {
        return selected_labels.join(", ");
      }

      return `${selected_labels[0]}, ${selected_labels[1]} +${selected_labels.length - 2}`;
    },

    all_compare_properties_selected() {
      const selected_ids = this.normalized_compare_property_ids();
      return this.compare_property_options.length > 0
        && this.compare_property_options.every((property) => selected_ids.includes(Number(property.id)));
    },
  },

  watch: {
    show_compare_selector(is_visible) {
      if (!is_visible) {
        this.is_compare_drawer_open = false;
      }
    },
  },

  methods: {
    normalized_compare_property_ids() {
      return this.compare_property_ids.map((property_id) => Number(property_id));
    },

    toggle_compare_drawer() {
      this.is_compare_drawer_open = !this.is_compare_drawer_open;
    },

    is_compare_property_selected(property_id) {
      return this.normalized_compare_property_ids().includes(Number(property_id));
    },

    toggle_compare_property(property_id) {
      const selected_ids = this.normalized_compare_property_ids();
      const normalized_id = Number(property_id);
      const next_ids = selected_ids.includes(normalized_id)
        ? selected_ids.filter((selected_id) => selected_id !== normalized_id)
        : [...selected_ids, normalized_id];

      this.$emit("update:compare_property_ids", next_ids);
    },

    select_all_compare_properties() {
      const next_ids = this.compare_property_options.map((property) => Number(property.id));
      this.$emit("update:compare_property_ids", next_ids);
    },

    clear_compare_properties() {
      this.$emit("update:compare_property_ids", []);
    },
  },
};
